//@ vendors
const trim = require('lodash/string/trim');
//@ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { getControlDigitFromCodBban } = require('utilities/ibanHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');
//@ constants
const actionTypes = require('constants/actionTypes');
const {
    DECLARATION_RESULT_TO_PAY
} = require('constants/index');

const setFractionPayment = fractionPayment => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_SET_FRACTION_PAYMENT,
    payload: {
        fractionPayment
    }
});

const setDifferentialFee = (differentialFee, bestBalanceAmount) => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_SET_DIFFERENTIAL_FEE,
    payload: {
        differentialFee,
        bestBalanceAmount
    }
});

const setDomiciliateSecondPayment = domiciliateSecondPayment => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_SET_DOMICILIATE_SECOND_PAYMENT,
    payload: {
        domiciliateSecondPayment
    }
});

const setAccount = accountId => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_SET_ACCOUNT,
    payload: {
        accountId
    }
});

const setAmountToReturn = amount => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_SET_AMOUNT,
    payload: {
        amount
    }
});

const setJustificative = justificative => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_SET_JUSTIFICATIVE,
    payload: {
        justificative
    }
});

const setDecalarationResult = declarationResult => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_SET_DECLARATION_RESULT,
    payload: {
        declarationResult
    }
});

const setVisibleStep = (step) => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_SET_VISIBLE_STEP,
    payload: { step }
})

const validateStep = (step) => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_VALIDATE_STEP,
    payload: { step }
})

const setWillCancel = (willCancel) => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_WILL_CANCEL,
    payload: { willCancel }
})

const clearRequest = () => ({ type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_CLEAR })

const successChange = (payload) => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_SUCCESS,
    payload
})

const failureChange = (error) => ({
    type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_FAILURE,
    payload: { error }
})

const requestChange = () => ({ type: actionTypes.TAX_AND_RENTS_PAYMENT_WITH_DRAFT_REQUEST })

const postPaymentWithDraft = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immStep = getState().taxAndRentsPaymentWithDraft.getIn(['steps', 0]);
        const immAccount = getState().accounts.getIn(['byId', immStep.get('accountId')]);
        const immProfile = getState().profile;
        const immLogin = getState().okLogin;
        const firstname = immProfile.get('nombreCliente');
        const lastname = immProfile.getIn(['apellidoUno', 'apellido']);
        const anagram = immProfile.getIn(['apellidoUno', 'apellido']).substr(0, 3) + immProfile.get('nombreCliente').substr(0, 1);
        const isPayment = immStep.get('declarationResult') === DECLARATION_RESULT_TO_PAY;
        const currency = immAccount.getIn(['balances', 'availableBalance', 'currency']);
        const domiciliateSecondPayment = immStep.get('domiciliateSecondPayment');
        const fractionPayment = immStep.get('fractionPayment')
        let amount = isPayment ? parseFloat(immStep.get('firstPayment')) : immStep.get('amountToReturn');
        let fractionPaymentCode;

        if (isPayment && !fractionPayment && domiciliateSecondPayment) {
            amount = immStep.get('differentialFee');
            fractionPaymentCode = '00';
        } else if (isPayment && !fractionPayment && !domiciliateSecondPayment) {
            amount = immStep.get('differentialFee');
            fractionPaymentCode = '01';
        } else if (isPayment && fractionPayment && !domiciliateSecondPayment) {
            fractionPaymentCode = '02';
        } else if (isPayment && fractionPayment && domiciliateSecondPayment) {
            fractionPaymentCode = '03';
        }

        const requestData = {
            query: {
                dataToken,
                anagramaCorto: anagram,
                apelNom: `${trim(lastname)} ${trim(firstname)}`,
                contratoSeleccionado: {
                    digitodecontrol: getControlDigitFromCodBban(immAccount.getIn(['ibanComplex', 'codbban'])),
                    numerodecuenta: immAccount.get('product') + immAccount.get('contractNumber')
                },
                descripcionSeleccionado: immAccount.get('description'),
                fraccionPago: fractionPaymentCode,
                identDeclarante: {
                    codigodedocumento: immLogin.get('username'),
                    tipodocumentoofic: immLogin.get('usernameType')
                },
                importePago: {
                    divisa: currency,
                    importe: amount
                },
                importeTotal: {
                    divisa: currency,
                    importe: amount
                },
                indTipoDecla: isPayment ? 0 : 1,
                modelo: 100,
                saldoSeleccionado: currency,
                justificante: immStep.get('justificative')
            }
        };

        dispatch(requestChange());
        APIPost(dispatch, apiURLBuilder.getURL('taxAndRentsPaymentWithDraft'), requestData)
            .then(response => dispatch(successChange(response)))
            .catch( response => {
                if (!!response.error) {
                    dispatch(failureChange(response.error))
                }
                else throw response;
            })
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    setVisibleStep,
    validateStep,
    setWillCancel,
    postPaymentWithDraft,
    clearRequest,
    setAccount,
    setAmountToReturn,
    setJustificative,
    setDecalarationResult,
    setDifferentialFee,
    setDomiciliateSecondPayment,
    setFractionPayment
}
